import { Component, OnInit, Input } from '@angular/core';
import { getLocaleFirstDayOfWeek } from '@angular/common';

@Component({
  selector: 'app-uleset-ne-parlament',
  templateUrl: './uleset-ne-parlament.component.html',
  styleUrls: ['./uleset-ne-parlament.component.css']
})
export class UlesetNeParlamentComponent implements OnInit {

  @Input() year: number;
  @Input() parties: any[] = [];

  selectedYear = 2017;
  totalNumbers = 0;

  color: any[] = [
    'red',
    'blue',
  ];

  circles2: any[] = [{"style":"fill:#008000","cx":"206","cy":"767"},{"style":"fill:#008000","cx":"167","cy":"699"},{"style":"fill:#008000","cx":"140","cy":"619"},{"style":"fill:#008000","cx":"104","cy":"552"},{"style":"fill:#008000","cx":"67","cy":"487"},{"style":"fill:#008000","cx":"31","cy":"422"},{"style":"fill:#008000","cx":"256","cy":"704"},{"style":"fill:#008000","cx":"219","cy":"638"},{"style":"fill:#008000","cx":"197","cy":"559"},{"style":"fill:#008000","cx":"161","cy":"494"},{"style":"fill:#008000","cx":"125","cy":"430"},{"style":"fill:#008000","cx":"90","cy":"367"},{"style":"fill:#008000","cx":"312","cy":"646"},{"style":"fill:#008000","cx":"277","cy":"582"},{"style":"fill:#008000","cx":"258","cy":"505"},{"style":"fill:#008000","cx":"223","cy":"442"},{"style":"fill:#008000","cx":"188","cy":"379"},{"style":"fill:#008000","cx":"153","cy":"316"},{"style":"fill:#008000","cx":"117","cy":"254"},{"style":"fill:#008000","cx":"375","cy":"595"},{"style":"fill:#008000","cx":"340","cy":"533"},{"style":"fill:#008000","cx":"325","cy":"457"},{"style":"fill:#008000","cx":"290","cy":"394"},{"style":"fill:#008000","cx":"254","cy":"333"},{"style":"fill:#008000","cx":"219","cy":"271"},{"style":"fill:#008000","cx":"183","cy":"209"},{"style":"fill:#008000","cx":"443","cy":"552"},{"style":"fill:#008000","cx":"408","cy":"490"},{"style":"fill:#008000","cx":"396","cy":"415"},{"style":"fill:#008000","cx":"360","cy":"353"},{"style":"fill:#008000","cx":"324","cy":"292"},{"style":"fill:#008000","cx":"288","cy":"230"},{"style":"fill:#008000","cx":"253","cy":"168"},{"style":"fill:#008000","cx":"592","cy":"489"},{"style":"fill:#008000","cx":"555","cy":"426"},{"style":"fill:#008000","cx":"548","cy":"354"},{"style":"fill:#008000","cx":"510","cy":"291"},{"style":"fill:#008000","cx":"473","cy":"228"},{"style":"fill:#008000","cx":"436","cy":"165"},{"style":"fill:#008000","cx":"671","cy":"471"},{"style":"fill:#008000","cx":"632","cy":"406"},{"style":"fill:#008000","cx":"628","cy":"334"},{"style":"fill:#008000","cx":"589","cy":"269"},{"style":"fill:#008000","cx":"551","cy":"205"},{"style":"fill:#008000","cx":"513","cy":"141"},{"style":"fill:#008000","cx":"751","cy":"462"},{"style":"fill:#008000","cx":"711","cy":"394"},{"style":"fill:#008000","cx":"709","cy":"322"},{"style":"fill:#008000","cx":"669","cy":"255"},{"style":"fill:#008000","cx":"630","cy":"189"},{"style":"fill:#008000","cx":"591","cy":"123"},{"style":"fill:#008000","cx":"553","cy":"58"},{"style":"fill:#008000","cx":"632","cy":"44"},{"style":"fill:#008000","cx":"671","cy":"111"},{"style":"fill:#008000","cx":"711","cy":"179"},{"style":"fill:#008000","cx":"751","cy":"248"},{"style":"fill:#008000","cx":"711","cy":"36"},{"style":"fill:#008000","cx":"751","cy":"105"},{"style":"fill:#008000","cx":"792","cy":"33"},{"style":"fill:#008000","cx":"792","cy":"176"},{"style":"fill:#008000","cx":"832","cy":"105"},{"style":"fill:#008000","cx":"872","cy":"36"},{"style":"fill:#008000","cx":"832","cy":"462"},{"style":"fill:#008000","cx":"792","cy":"390"},{"style":"fill:#008000","cx":"792","cy":"318"},{"style":"fill:#008000","cx":"832","cy":"248"},{"style":"fill:#008000","cx":"872","cy":"179"},{"style":"fill:#008000","cx":"912","cy":"111"},{"style":"fill:#008000","cx":"951","cy":"44"},{"style":"fill:#008000","cx":"872","cy":"394"},{"style":"fill:#008000","cx":"874","cy":"322"},{"style":"fill:#008000","cx":"914","cy":"255"},{"style":"fill:#008000","cx":"953","cy":"189"},{"style":"fill:#008000","cx":"992","cy":"123"},{"style":"fill:#008000","cx":"1030","cy":"58"},{"style":"fill:#008000","cx":"912","cy":"471"},{"style":"fill:#008000","cx":"951","cy":"406"},{"style":"fill:#008000","cx":"955","cy":"334"},{"style":"fill:#008000","cx":"994","cy":"269"},{"style":"fill:#008000","cx":"1032","cy":"205"},{"style":"fill:#008000","cx":"1070","cy":"141"},{"style":"fill:#008000","cx":"991","cy":"489"},{"style":"fill:#008000","cx":"1028","cy":"426"},{"style":"fill:#008000","cx":"1035","cy":"354"},{"style":"fill:#008000","cx":"1073","cy":"291"},{"style":"fill:#008000","cx":"1110","cy":"228"},{"style":"fill:#008000","cx":"1147","cy":"165"},{"style":"fill:#008000","cx":"1140","cy":"552"},{"style":"fill:#008000","cx":"1175","cy":"490"},{"style":"fill:#008000","cx":"1187","cy":"415"},{"style":"fill:#008000","cx":"1223","cy":"353"},{"style":"fill:#008000","cx":"1259","cy":"292"},{"style":"fill:#008000","cx":"1295","cy":"230"},{"style":"fill:#008000","cx":"1330","cy":"168"},{"style":"fill:#008000","cx":"1208","cy":"595"},{"style":"fill:#008000","cx":"1243","cy":"533"},{"style":"fill:#008000","cx":"1258","cy":"457"},{"style":"fill:#008000","cx":"1293","cy":"394"},{"style":"fill:#008000","cx":"1329","cy":"333"},{"style":"fill:#008000","cx":"1364","cy":"271"},{"style":"fill:#008000","cx":"1400","cy":"209"},{"style":"fill:#008000","cx":"1271","cy":"646"},{"style":"fill:#008000","cx":"1306","cy":"582"},{"style":"fill:#008000","cx":"1325","cy":"505"},{"style":"fill:#008000","cx":"1360","cy":"442"},{"style":"fill:#008000","cx":"1395","cy":"379"},{"style":"fill:#008000","cx":"1430","cy":"316"},{"style":"fill:#008000","cx":"1466","cy":"254"},{"style":"fill:#008000","cx":"1327","cy":"704"},{"style":"fill:#008000","cx":"1364","cy":"638"},{"style":"fill:#008000","cx":"1386","cy":"559"},{"style":"fill:#008000","cx":"1422","cy":"494"},{"style":"fill:#008000","cx":"1458","cy":"430"},{"style":"fill:#008000","cx":"1493","cy":"367"},{"style":"fill:#008000","cx":"1377","cy":"767"},{"style":"fill:#008000","cx":"1416","cy":"699"},{"style":"fill:#008000","cx":"1443","cy":"619"},{"style":"fill:#008000","cx":"1479","cy":"552"},{"style":"fill:#008000","cx":"1516","cy":"487"},{"style":"fill:#008000","cx":"1552","cy":"422"}];
  
  constructor() { }

  ngOnInit() {
   this.selectedYear = this.year;

   let count = 0;
   let lastCount = 0;

   for(let i=0; i < this.parties.length; i++) {
     for(count; count<lastCount+this.parties[i].chairs; count++) {
       this.circles[count].style = this.parties[i].color;
     }
     lastCount = count;
   }
   this.totalNumbers = count;

   for(count; count<120; count++) {
     this.circles[count].style = 'grey';
   }
 }

 ngOnChanges() {
   if(this.selectedYear !== this.year) {
     this.ngOnInit();
   } else if (this.parties.length != 0) {
     this.ngOnInit();
   }
 }

  circles: any[] = 
  [
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M471 1437l-59 -163c-40,37 -78,75 -114,114l67 126c44,-18 67,-39 106,-77z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M589 1331l-58 -157c-41,32 -80,65 -119,100l59 163c38,-38 77,-73 118,-106z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M711 1239l-56 -154c-42,28 -83,58 -124,89l58 157c39,-33 80,-64 122,-92z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M838 1159l-55 -151c-43,24 -86,50 -128,77l56 153c41,-28 84,-54 127,-79z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M969 1092l-54 -150c-45,21 -89,43 -132,66l55 151c43,-24 87,-47 131,-67z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1105 1036l-54 -149c-46,17 -91,35 -136,55l54 150c45,-21 90,-40 136,-56z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M412 1274l-58 -160c-40,35 -79,71 -117,109l61 165c36,-39 74,-77 114,-114z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M531 1174l-56 -156c-42,31 -82,63 -121,96l58 160c39,-35 78,-68 119,-100z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M655 1085l-55 -152c-43,27 -85,55 -125,85l56 156c41,-31 82,-61 124,-89z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M783 1008l-55 -150c-43,23 -86,48 -128,75l55 152c42,-27 85,-53 128,-77z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M915 942l-54 -149c-45,20 -89,42 -133,65l55 150c43,-23 87,-45 132,-66z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1051 887l-54 -149c-46,17 -92,35 -136,55l54 149c45,-20 90,-38 136,-55z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M354 1114l-58 -158c-40,33 -80,68 -118,104l59 163c38,-38 77,-74 117,-109z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M475 1018l-57 -155c-41,30 -82,61 -122,93l58 158c39,-33 79,-65 121,-96z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M600 933l-56 -152c-42,26 -84,53 -126,82l57 155c40,-30 82,-58 125,-85z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M728 858l-54 -150c-44,23 -87,47 -130,73l56 152c42,-27 85,-52 128,-75z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M861 793l-54 -149c-45,20 -90,41 -133,64l54 150c44,-23 88,-45 133,-65z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M997 738l-54 -149c-46,17 -92,35 -136,55l54 149c44,-20 90,-38 136,-55z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M296 956l-57 -157c-41,32 -81,65 -120,100l59 161c38,-36 78,-71 118,-104z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M418 863l-55 -153c-42,28 -84,58 -124,89l57 157c40,-32 81,-63 122,-93z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M544 781l-55 -152c-43,26 -85,53 -126,81l55 153c42,-29 84,-56 126,-82z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M674 708l-55 -150c-44,22 -87,46 -130,71l55 152c43,-26 86,-50 130,-73z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M807 644l-55 -149c-45,20 -89,41 -133,63l55 150c43,-23 88,-44 133,-64z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M943 589l-55 -148c-45,16 -91,34 -136,54l55 149c44,-20 90,-38 136,-55z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M239 799l-57 -155c-41,30 -81,62 -121,96l58 159c39,-35 79,-68 120,-100z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M363 710l-56 -153c-42,27 -84,56 -125,87l57 155c40,-31 82,-61 124,-89z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M489 629l-55 -151c-43,25 -85,51 -127,79l56 153c41,-28 83,-55 126,-81z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M619 558l-54 -150c-44,22 -88,46 -131,70l55 151c43,-25 86,-49 130,-71z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M752 495l-54 -149c-45,19 -89,40 -133,62l54 150c44,-22 88,-43 133,-63z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M888 441l-54 -149c-46,17 -91,35 -136,54l54 149c45,-20 91,-38 136,-54z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M182 644l-56 -155c-41,30 -82,61 -122,93l57 158c0,0 0,0 0,0 40,-34 80,-66 121,-96z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M182 644c41,-31 83,-60 125,-87l-56 -153c-42,27 -84,55 -125,85l56 155z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M434 478l-55 -151c-43,25 -86,50 -128,77l56 153c42,-28 84,-54 127,-79z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M565 408l-55 -150c-44,22 -88,45 -131,69l55 151c43,-24 87,-48 131,-70z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M698 346l-54 -149c-45,19 -90,40 -134,61l55 150c44,-22 88,-43 133,-62z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M834 292l-54 -149c-46,17 -91,35 -136,54l54 149c45,-19 90,-37 136,-54z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1401 956l-36 -154c-8,1 -16,3 -24,5 -49,9 -97,20 -144,33l54 149c50,-13 100,-24 150,-33z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1553 936l-18 -157c-16,1 -33,3 -49,5 -41,5 -81,11 -121,18l36 154c50,-9 101,-15 152,-20z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1707 930l0 -159c0,0 0,0 0,0 -25,0 -49,1 -74,2 -33,1 -65,3 -98,6l18 157c51,-4 102,-6 154,-6z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "2.08323",
       "d": "M1860 936l18 -157c-32,-3 -65,-5 -97,-6 -25,-1 -50,-2 -74,-2l0 159c51,0 102,2 153,6z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2012 956l37 -154c-40,-7 -81,-13 -122,-18 -16,-2 -32,-4 -49,-5l-18 157c51,5 102,11 152,20z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2162 989l54 -149c-47,-13 -95,-24 -143,-33 -8,-2 -16,-4 -24,-5l-37 154c51,9 101,20 150,33z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1341 807l-40 -154c-6,1 -13,3 -20,4 -46,10 -93,21 -138,34l54 149c47,-13 95,-24 144,-33z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1486 784l-24 -157c-13,2 -27,4 -40,6 -41,5 -81,12 -121,20l40 154c8,-2 16,-4 24,-5 40,-7 80,-13 121,-18z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1633 773l-8 -158c-20,0 -41,1 -61,3 -34,2 -68,5 -102,9l24 157c16,-2 33,-4 49,-5 33,-3 65,-5 98,-6z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1781 773l7 -158c-27,-1 -54,-2 -81,-2 -1,0 -1,0 -1,0 -27,0 -54,1 -81,2l8 158c25,-1 49,-2 74,-2 0,0 0,0 0,0 24,0 49,1 74,2z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1927 784l24 -157c-34,-4 -68,-7 -102,-9 -20,-2 -41,-3 -61,-3l-7 158c32,1 65,3 97,6 17,1 33,3 49,5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2073 807l39 -154c-40,-8 -81,-15 -122,-21 -13,-1 -26,-3 -39,-5l-24 157c41,5 82,11 122,18 8,1 16,3 24,5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2216 840l54 -149c-46,-13 -92,-24 -139,-34 -6,-2 -13,-3 -19,-4l-39 154c48,9 96,20 143,33z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1281 657l-41 -153c-51,11 -101,23 -152,38l55 149c45,-13 92,-24 138,-34z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1422 633l-28 -156c-51,7 -103,16 -154,27l41 153c7,-1 14,-3 20,-4 40,-8 80,-15 121,-20z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1564 618l-14 -158c-52,4 -104,9 -156,17l28 156c13,-2 27,-4 40,-6 34,-4 68,-7 102,-9z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1706 613l1 -158c-53,0 -105,2 -157,5l14 158c20,-2 41,-3 61,-3 27,-1 54,-2 81,-2z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1849 618l14 -158c-52,-3 -104,-5 -156,-5 0,0 0,0 0,0l-1 158c0,0 0,0 1,0 27,0 54,1 81,2 20,0 41,1 61,3z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1990 632l29 -155c-52,-8 -104,-13 -156,-17l-14 158c34,2 68,5 102,9 13,2 26,4 39,5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2131 657l42 -153c-51,-11 -103,-20 -154,-27l-29 155c41,6 82,13 122,21 0,0 0,0 0,0 6,1 13,2 19,4z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2270 691l55 -149c-50,-15 -101,-27 -152,-38l-42 153c47,10 93,21 139,34z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1240 504l-41 -153c-6,1 -12,2 -18,4 -49,11 -98,24 -147,38l54 149c51,-15 101,-27 152,-38z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1394 477l-27 -156c-12,1 -25,3 -37,5 -44,7 -87,15 -131,25l41 153c51,-11 103,-20 154,-27z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1550 460l-13 -158c-19,2 -38,3 -57,5 -38,4 -75,8 -113,14l27 156c52,-8 104,-13 156,-17z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1707 455l0 -159c0,0 0,0 0,0 -26,0 -51,1 -76,2 -31,1 -63,2 -94,4l13 158c52,-3 104,-5 157,-5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1863 460l14 -158c-31,-2 -63,-3 -94,-4 -25,-1 -51,-2 -76,-2l0 159c0,0 0,0 0,0 52,0 104,2 156,5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2019 477l28 -156c-38,-6 -75,-10 -113,-14 -19,-2 -38,-3 -57,-5l-14 158c52,4 104,9 156,17z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2173 504l42 -153c-44,-9 -87,-18 -131,-25 -12,-2 -25,-4 -37,-5l-28 156c51,7 103,16 154,27z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2325 542l54 -149c-48,-14 -97,-27 -146,-38 -6,-1 -12,-3 -18,-4l-42 153c51,11 102,23 152,38z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1181 354l-39 -141c-6,1 -11,2 -16,3 -48,12 -95,24 -142,39l50 138c49,-15 98,-27 147,-39z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1181 354c49,-11 99,-21 149,-29l-29 -144c-10,2 -21,4 -32,5 -43,8 -85,17 -127,27l39 141z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1330 325c50,-8 100,-14 150,-19l-17 -146c-16,1 -32,3 -49,5 -37,5 -75,10 -113,16l29 144z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1632 296l-6 -147c-22,1 -44,2 -65,3 -33,2 -66,5 -98,8l17 146c51,-5 101,-8 152,-10z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1783 296l6 -147c-27,-1 -54,-1 -82,-1 0,0 0,0 0,0 -27,0 -54,0 -81,1l6 147c25,-1 50,-1 75,-1 26,0 51,0 76,1z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1783 296c51,2 102,5 152,10l16 -146c-32,-3 -65,-6 -97,-8 -22,-1 -44,-2 -65,-3l-6 147z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1935 306c50,5 100,11 150,19l28 -144c-37,-6 -75,-12 -113,-16 -16,-2 -32,-4 -49,-5l-16 146z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2085 325c50,8 100,18 149,29l39 -142c-42,-9 -85,-18 -128,-26 -11,-2 -21,-3 -32,-5l-28 144z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2234 354c49,12 98,24 147,39l50 -138c-47,-15 -94,-27 -142,-39 -5,-1 -11,-2 -16,-4l-39 142z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M984 255c47,-15 94,-27 142,-39l-41 -141c-51,12 -101,26 -151,41l50 139z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1126 216c0,0 0,0 0,0zm16 -3c42,-10 84,-19 127,-27l-30 -143c-52,9 -103,20 -154,32l41 141c16,-3 0,0 16,-3z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1301 181c38,-6 76,-11 113,-16l-20 -145c-52,6 -104,13 -155,23l30 143c11,-1 22,-3 32,-5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1463 160c32,-3 65,-6 98,-8l-10 -146c-53,3 -105,7 -157,14l20 145c17,-2 33,-4 49,-5z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1626 149c27,-1 54,-1 81,-1l0 -147c-52,0 -104,2 -156,5l10 146c21,-1 43,-2 65,-3z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1854 152l10 -146c-52,-3 -104,-5 -157,-5l0 147c0,0 0,0 0,0 28,0 55,0 82,1 21,1 43,2 65,3z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M1951 160c17,1 33,3 49,5l21 -145c-52,-7 -104,-11 -157,-14l-10 146c32,2 65,5 97,8z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2113 181c11,2 21,3 32,5l31 -143c-51,-10 -103,-17 -155,-23l-21 145c38,4 76,10 113,16z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2145 186c43,8 86,17 128,26l0 1 0 0 16 3c0,0 0,0 0,0l41 -141c-51,-12 -102,-23 -154,-32l-31 143z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2289 216c48,12 95,24 142,39l50 -139c-50,-15 -100,-29 -151,-41l-41 141z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2498 942c-44,-20 -90,-38 -136,-55l-54 149c46,16 91,35 136,56l54 -150z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2630 1008c-43,-23 -87,-45 -132,-66l-54 150c45,20 88,43 131,67l55 -151z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2630 1008l-55 151c44,25 86,51 127,80l56 -154c-42,-27 -84,-53 -128,-77z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2758 1085l-56 154c42,28 83,59 123,92l57 -157c-40,-31 -82,-61 -124,-89z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2882 1174l-57 157c40,33 79,68 117,106l59 -163c-38,-35 -78,-68 -119,-100z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3001 1274l-59 163c39,38 66,64 104,77l70 -126c-37,-39 -75,-77 -115,-114z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2498 942l54 -149c-44,-20 -90,-38 -136,-55l-54 149c46,17 92,35 136,55z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2552 793l-54 149c45,21 89,43 132,66l55 -150c-44,-23 -88,-45 -133,-65z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2685 858l-55 150c44,24 86,50 128,77l56 -152c-42,-27 -85,-52 -129,-75z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2814 933l-56 152c42,28 84,58 124,89l56 -156c-40,-30 -82,-58 -124,-85z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2938 1018l-56 156c41,32 81,65 119,100l58 -160c-39,-33 -79,-65 -121,-96z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3059 1114l-58 160c40,37 78,75 115,114l60 -165c-38,-38 -76,-74 -117,-109z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2416 738c46,17 92,35 136,55l55 -149c-45,-20 -90,-38 -136,-55l-55 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2552 793c45,20 89,42 133,65l54 -150c-43,-23 -87,-44 -132,-64l-55 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2739 708l-54 150c44,23 87,48 129,75l55 -152c-42,-26 -86,-50 -130,-73z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2869 781l-55 152c42,27 84,55 124,85l57 -155c-41,-29 -83,-56 -126,-82z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2995 863l-57 155c42,31 82,63 121,96l58 -158c-40,-32 -81,-63 -122,-93z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3117 956l-58 158c41,35 79,71 117,109l59 -163c-38,-36 -77,-71 -118,-104z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2471 589c46,17 91,35 136,55l54 -149c-45,-20 -90,-38 -136,-54l-54 148z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2607 644c45,20 89,41 132,64l55 -150c-44,-22 -88,-43 -133,-63l-54 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2739 708c44,23 88,47 130,73l55 -152c-43,-25 -86,-49 -130,-71l-55 150z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2869 781c43,26 85,53 126,82l56 -153c-42,-28 -84,-55 -127,-81l-55 152z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2995 863c41,30 82,61 122,93l57 -157c-40,-31 -81,-61 -123,-89l-56 153z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3174 799l-57 157c41,33 80,68 118,104l59 -161c-39,-35 -79,-68 -120,-100z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2525 441c46,16 91,34 136,54l54 -149c-45,-19 -90,-37 -136,-54l-54 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2661 495c45,20 89,41 133,63l55 -150c-44,-22 -89,-43 -134,-62l-54 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2794 558c44,22 87,46 130,71l55 -151c-43,-24 -86,-48 -130,-70l-55 150z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2924 629c43,26 85,53 127,81l55 -153c-41,-28 -84,-54 -127,-79l-55 151z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3051 710c42,28 83,58 123,89l57 -155c-41,-31 -82,-60 -125,-87l-55 153z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3231 644l-57 155c41,32 81,65 120,100l58 -159c-40,-34 -80,-66 -121,-96z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2579 292c46,17 91,35 136,54l54 -149c-45,-19 -90,-37 -136,-54l-54 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2715 346c45,19 90,40 134,62l54 -150c-44,-21 -88,-42 -134,-61l-54 149z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2849 408c44,22 87,46 130,70l55 -151c-43,-24 -87,-47 -131,-69l-54 150z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M2979 478c43,25 86,51 127,79l56 -153c-42,-27 -85,-52 -128,-77l-55 151z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3106 557c43,27 84,56 125,87l56 -155c-41,-30 -83,-58 -125,-85l-56 153z"
    },
    {
       "fill": "#7D4A1D",
       "stroke": "#373435",
       "stroke-width": "1.99938",
       "d": "M3287 489l-56 155c41,30 81,62 121,96l57 -158c-40,-32 -80,-63 -122,-93z"
    }
 ]


}
